import { upsellPageDataDbWriteValidator } from "@redotech/redo-model/upsell-page/upsell-page-db-validator";
import * as z from "zod/v4";

const productInfoSchema_ = z.object({
  imageUrl: z.string().optional(),
  name: z.string(),
});
const productInfoSchema: z.ZodType<ProductInfo> = productInfoSchema_;
export interface ProductInfo extends z.infer<typeof productInfoSchema_> {}

export const getUpsellPage = {
  name: "getUpsellPage" as const,
  input: z.object({ upsellPageId: z.string() }),
  output: z
    .object({
      upsellPageId: z.string(),
      upsellPageData: upsellPageDataDbWriteValidator,
      createdAt: z.date(),
      name: z.string().optional(),
      // productId -> productInfo
      productInfo: z.map(z.string(), productInfoSchema),
      // collectionId -> collectionInfo
      collectionInfo: z.map(z.string(), z.object({ name: z.string() })),
    })
    .nullable(),
};
